export default function changeCities() {
    const stateElements = document.querySelectorAll("[states]");
    const citiesUrlElement = document.getElementById("citiesUrl");

    if (stateElements && citiesUrlElement) {
        stateElements.forEach(stateElement => {
            stateElement.addEventListener('change', function () {
                const url = citiesUrlElement.value;
                const stateValue = stateElement.value;
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    },
                    body: `state=${stateValue}`,
                })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`Network response was not ok: ${response.statusText}`);
                    }
                    return response.text();
                })
                .then(html => {
                    const cityId = stateElement.getAttribute('city');
                    const cityElement = document.getElementById(cityId);
                    if (cityElement) {
                        cityElement.innerHTML = html;
                    }
                })
                .catch(error => {
                    console.error("Error fetching cities:", error);
                });
            });
        })
    }
}
